import React from "react";
import ReactDOM from "react-dom";
import { IoClose } from "react-icons/io5";
import { deleteUserFirestoreData } from "../../data/accountRepo";
import { useAuth } from "../../context/AuthContext";
import "./DeleteAccountModal.css";

export default function DeleteAccountModal({ onClose }) {
  const {
    user,
    signOut,
    reauthenticateWithPassword,
    deleteCurrentUser,
  } = useAuth();

  async function handleConfirmDelete() {
    try {
      // 1. Delete Firestore data
      await deleteUserFirestoreData({ uid: user.uid });
  
      // 2. Try deleting Firebase Auth user
      await deleteCurrentUser();
  
      // 3. Sign out (to clear session)
      await signOut();
  
      // 4. Redirect
      window.location.href = "/";
    } catch (err) {
      if (err.code === "auth/requires-recent-login") {
        const password = prompt("Digite novamente sua senha para confirmar a exclusão:");
  
        if (!password) return;
  
        // Reauthenticate
        await reauthenticateWithPassword(password);
  
        // Retry deletion
        await deleteCurrentUser();
  
        // Sign out after deletion
        await signOut();
  
        // Redirect
        window.location.href = "/";
      } else {
        console.error("Delete error:", err);
        alert("An unexpected error occurred.");
      }
    }
  }

  return ReactDOM.createPortal(
    <div className="delete-overlay" onClick={onClose}>
      <div
        className="delete-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="delete-close" onClick={onClose}>
          <IoClose size={22} />
        </button>

        <h2 className="delete-title">Excluir conta?</h2>
        <p className="delete-desc">
        Esta ação é permanente. Todos os seus dados serão apagados para sempre.
        </p>

        <button className="delete-confirm-btn" onClick={handleConfirmDelete}>
        Sim, excluir minha conta
        </button>
        <button className="delete-cancel-btn" onClick={onClose}>
        Cancelar
        </button>
      </div>
    </div>,
    document.body
  );
}
